import { useEffect } from "react"
import { i18n } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import {
  contactUsUrl,
  footerUrl,
  headerUrl,
  previewContentPrefix,
  DEFAULT_CARD_DETAILS_API_PATH,
  blogUrl,
} from "@/constants"
import AemGrid from "@/components/AemGrid"
import {
  buildUrlForAemApim,
  filterBackEndJson,
  getClienIP,
  getDataLayerObj,
} from "@/utils/helper"
import {
  aemApimAxiosInstance,
  aemAxiosInstance,
  aemPreviewAxiosInstance,
} from "@/constants/api"
import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import BreadCrumb from "@/components/Default/BreadCrumb"
import usePageAuth from "@/hooks/usePageAuth"
import { breadcrumbAnalytics } from "@/components/CustomerSupport/analytics"
import { useDispatch } from "react-redux"
import {
  setDatalayerPageName,
  setGbhDataLayerCustom,
} from "@/store/features/genericSlice"

const BlogPage = props => {
  const {
    genericListData,
    tmpData: data,
    headertmp: header,
    footertmp: footer,
    ip,
    globalScript,
    footerScript,
    analyticsData,
    gbhDataLayerCustom,
    datalayerPageName,
  } = props

  usePageAuth()
  useEffect(() => {
    getDataLayerObj(analyticsData)
  }, [analyticsData])

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setDatalayerPageName(datalayerPageName))
    dispatch(setGbhDataLayerCustom(gbhDataLayerCustom))
    return () => {
      dispatch(setDatalayerPageName(""))
      dispatch(setGbhDataLayerCustom(""))
    }
  }, [])

  useEffect(() => {
    if (ip) sessionStorage.setItem("true-ip", ip)
  }, [ip])
  return (
    <>
      <GlobalPageHeader
        header={header}
        title={data?.title}
        globalScripting={globalScript}
      />
      <AemGrid
        data={data}
        count={0}
        breadCrumb={(data, fullData) => (
          <BreadCrumb
            data={data}
            fullData={fullData}
            analyticsEvent={breadcrumbAnalytics}
          />
        )}
      />
      <GlobalPageFooter footer={footer} footerScripting={footerScript} />
    </>
  )
}

/**
 * Get ServerSideProps together.
 * @param {Object} request The first number.
 * @return {object} The props.
 */
export async function getServerSideProps({ req, locale }) {
  await i18n?.reloadResources()
  const isPreviewMode = req.cookies["aem-author-preview-mode"]
  const ip = getClienIP(req)
  const { url = "" } = req
  const cleanUrl = url.split("?")[0]
  const splitUrl = cleanUrl.split("/")
  const blogLandingUrl = splitUrl[3]
    ? cleanUrl + ".model.json"
    : "/blog.model.json"

  const { data } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: previewContentPrefix + blogLandingUrl,

        method: "GET",
      })
    : await aemApimAxiosInstance({
        url: `${buildUrlForAemApim(`${blogLandingUrl}.model.json`)}`,
        method: "GET",
      })
  const { data: header } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${data.headerExpFrg ? data.headerExpFrg : headerUrl}.model.json`,
        method: "GET",
      })
    : await aemApimAxiosInstance({
        url: data.headerExpFrg
          ? buildUrlForAemApim(`${data.headerExpFrg}.model.json`)
          : buildUrlForAemApim(`${headerUrl}.model.json`),
        method: "get",
      })

  const { data: footer } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${data.footerExpFrg ? data.footerExpFrg : footerUrl}.model.json`,
        method: "GET",
      })
    : await aemApimAxiosInstance({
        url: data.footerExpFrg
          ? buildUrlForAemApim(`${data.footerExpFrg}.model.json`)
          : buildUrlForAemApim(`${footerUrl}.model.json`),
        method: "GET",
      })
  const { data: genericList } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${DEFAULT_CARD_DETAILS_API_PATH}`,
        method: "GET",
      })
    : await aemApimAxiosInstance({
        url: buildUrlForAemApim(`${DEFAULT_CARD_DETAILS_API_PATH}`),
        method: "GET",
      })

  const { data: serviceRequest } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${genericList?.serviceRequest}`,
        method: "GET",
      })
    : await aemApimAxiosInstance({
        url: `${buildUrlForAemApim(
          `${genericList?.serviceRequest}.model.json`
        )}`,
        method: "GET",
      })

  const { data: productDetails } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${genericList?.productDetails}`,
        method: "GET",
      })
    : await aemApimAxiosInstance({
        url: `${buildUrlForAemApim(
          `${genericList?.productDetails}.model.json`
        )}`,
        method: "GET",
      })

  const globalScript = data?.globalScript
  const footerScript = data?.footerScript
  const topHeadScript = data?.topHeadScript ? data?.topHeadScript : null
  const gbhDataLayerCustom = {}
  if (data?.datalayerPageName) {
    gbhDataLayerCustom.datalayerPageName = data?.datalayerPageName
  }
  if (data?.eventPageType) {
    gbhDataLayerCustom.eventPageType = data?.eventPageType
  }
  let tmpData = {}
  if (data.pageComponentProperties) {
    tmpData = data.pageComponentProperties
  } else {
    tmpData = data
  }
  tmpData = filterBackEndJson(tmpData)
  const headertmp = filterBackEndJson(header)
  const footertmp = filterBackEndJson(footer)
  const analyticsData = data?.data
  const datalayerPageName = data?.datalayerPageName
  const genericListData = {
    serviceRequest: serviceRequest,
    productDetails: productDetails,
  }
  return {
    props: {
      ip,
      genericListData,
      tmpData,
      headertmp,
      footertmp,
      globalScript,
      footerScript,
      topHeadScript,
      analyticsData,
      datalayerPageName,
      gbhDataLayerCustom,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  }
}

export default BlogPage
